// The Qualified Leads count for the phone's Leads tab badge (lead_lane_counts, signed-in read). Refreshes when the app returns to the foreground. null until known.
import { useLaneCount } from './laneCounts';

export function useQualifiedCount(enabled) {
  return useLaneCount('ready_to_send', enabled);
}
